import { render, staticRenderFns } from "./CmgMemberRewards.vue?vue&type=template&id=006ae204&lang=pug&"
import script from "./cmg-member-rewards.ts?vue&type=script&lang=ts&"
export * from "./cmg-member-rewards.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports